{
  "cycle.entite.documents_publications": "Document version publications",
  "cycle.entite.documents_signatures": "Document version signatures",
  "cycle.entite.preuves_documents": "Evidence attached to documents",
  "journalAudit.action.approval.decided": "Decision made on a document",
  "journalAudit.action.approval.signed": "Document signature recorded",
  "journalAudit.action.document.evidence_attached": "Evidence attached to a document",
  "journalAudit.action.document.evidence_reevaluated": "Document evidence re-evaluated",
  "journalAudit.action.document.published": "Document version published",
  "journalAudit.action.document.version_abandoned": "Document version abandoned",
  "journalAudit.action.process.gate_refused": "Phase gate refused",
  "journalAudit.action.taxonomy.renamed": "Label or section renamed",
  "journalAudit.action.waiver.withdrawn": "Waiver request withdrawn"
}
